<template>
    <div class="product_list_vtwo">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>

        <section class="cmn-section item-category-list pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40">
                                    {{
                                        CategoryTitle(selected_category)
                                            | capitalize
                                    }}
                                </span>
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Our Best Selling Items
                            </h3>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="float-right short_by">
                            <div class="select_option sec_opt">
                                <label>Sort by</label>
                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(sorting) => sorting.value"
                                        v-model="sortBy"
                                        :options="sorting_array"
                                        :placeholder="'Sort by'"
                                    ></v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 apparel">
                        <div class="row">
                            <!-- Side Bar Start Here -->
                            <!-- <ProductAttributeFilters :prod_attr_values="prod_attr_values" @updateAttrFilters="getProductsByFilters" /> -->
                            <div class="col-md-12 col-lg-4 col-xl-2">
                                <div class="side_bar filter">
                                    <div class="categorys">
                                        <div
                                            class="accordion"
                                            id="accordionExample"
                                        >
                                            <div
                                                v-if="
                                                    applied_filters.length > 0
                                                "
                                            >
                                                <div>
                                                    <button
                                                        class="category_link w-100 d-flex"
                                                        style="cursor: default"
                                                        type="button"
                                                    >
                                                        <span
                                                            >Applied
                                                            Facets</span
                                                        >
                                                    </button>
                                                </div>
                                                <div
                                                    class="category_checkbox_show"
                                                >
                                                    <div
                                                        class="category_checkbox"
                                                    >
                                                        <div
                                                            class="form-check pl_8 py_6"
                                                            v-for="(
                                                                filter, index
                                                            ) in applied_filters"
                                                            :key="index"
                                                        >
                                                            <label
                                                                class="checkbox_custom p-0 d-table"
                                                            >
                                                                <img
                                                                    @click="
                                                                        removeAppliedFilters(
                                                                            filter
                                                                        )
                                                                    "
                                                                    src="/maincss/images/cross_red_circle.png"
                                                                    width="15"
                                                                    class="mr-1"
                                                                />
                                                                <span
                                                                    style="
                                                                        cursor: default;
                                                                    "
                                                                    >{{
                                                                        filter.option_label
                                                                            | capitalize
                                                                    }}</span
                                                                >
                                                            </label>
                                                        </div>
                                                        <a
                                                            @click="
                                                                clearFilters(
                                                                    'all'
                                                                )
                                                            "
                                                            class="font_size_13 text-danger btn_link mt_14 pl_8"
                                                        >
                                                            Clear All
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- BRANDS -->
                                            <AttributeFilter
                                                id="Brands"
                                                name="Brands"
                                                index="Brands"
                                                type="brandIds"
                                                :active="true"
                                                :options="
                                                    prod_attr_values.brands_list
                                                "
                                                :show-more-options="
                                                    isbrandShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('isbrandShowMore')
                                                "
                                            />

                                            <!-- Categories -->
                                            <AttributeFilter
                                                id="Categories"
                                                name="Categories"
                                                index="Categories"
                                                type="categoryIds"
                                                option-label="title"
                                                :options="
                                                    prod_attr_values.category_list
                                                "
                                                :show-more-options="
                                                    iscategoryShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore(
                                                        'iscategoryShowMore'
                                                    )
                                                "
                                            />

                                            <!-- COLOR SHADES -->
                                            <AttributeFilter
                                                id="ColorShades"
                                                name="Colors"
                                                index="ColorShades"
                                                type="colorShades"
                                                :storeKey="'name'"
                                                :options="
                                                    prod_attr_values.color_shades_list
                                                "
                                                :show-more-options="
                                                    iscolorShadesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore(
                                                        'iscolorShadesShowMore'
                                                    )
                                                "
                                            />

                                            <!-- SIZE GROUPS -->
                                            <!-- <AttributeFilter 
                                                id="SizeGroupings"
                                                name="Size Groupings" 
                                                index="SizeGroupings"
                                                type="size_groupings"
                                                :options="prod_attr_values.gender_age_list"
                                                option-label="gender"
                                                :show-more-options="isgenderAgeShowMore"
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="showMore('isgenderAgeShowMore')"
                                            /> -->

                                            <!-- SIZES -->
                                            <AttributeFilter
                                                id="Sizes"
                                                name="Sizes"
                                                index="Sizes"
                                                type="sizeIds"
                                                :options="
                                                    prod_attr_values.sizes_list
                                                "
                                                option-label="size"
                                                :show-more-options="
                                                    issizesShowMore
                                                "
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="
                                                    showMore('issizesShowMore')
                                                "
                                            />

                                            <!-- PRICES -->
                                            <!-- <AttributeFilter 
                                                id="Prices"
                                                name="Prices" 
                                                index="Prices"
                                                type="priceRanges"
                                                :options="prod_attr_values.price_ranges"
                                                :show-more-options="ispricesShowMore"
                                                :config="listConfig"
                                                @clearFilters="clearFilters"
                                                @filterProducts="filterProducts"
                                                @showMore="showMore('ispricesShowMore')"
                                            /> -->

                                            <!-- ATTRIBUTES -->
                                            <div
                                                v-for="(
                                                    attribute, attribute_index
                                                ) in prod_attr_values.attributes_list"
                                                :key="attribute_index"
                                            >
                                                <AttributeFilter
                                                    :id="`Attribute-${attribute.id}`"
                                                    :name="
                                                        attribute.attribute_name
                                                    "
                                                    :index="attribute_index"
                                                    :options="
                                                        attribute.AttributeOptions
                                                    "
                                                    :show-more-options="
                                                        attribute.show_more
                                                    "
                                                    :config="listConfig"
                                                    type="attribute_options"
                                                    option-label="category"
                                                    @clearFilters="clearFilters"
                                                    @filterProducts="
                                                        filterProducts
                                                    "
                                                    @showMore="
                                                        showMore(attribute)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Side Bar End Here -->
                            <div class="col-md-12 col-lg-8 col-xl-10">
                                <ProductListGrid
                                    :product_object="product_list"
                                    :columns="'3'"
                                ></ProductListGrid>
                                <div
                                    class="product-info"
                                    v-if="product_list.length"
                                >
                                    Showing {{ startRange }}-{{ endRange }} of
                                    {{ category_length }} products
                                </div>
                                <div
                                    class="pagination_margin productlist_pagination_custom"
                                    v-if="product_list.length"
                                >
                                    <b-pagination
                                        v-show="category_length > itemsPerPage"
                                        v-model="currentPage"
                                        :total-rows="pagination_data_length"
                                        :per-page="itemsPerPage"
                                        class="imprint_pagination"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isBusy">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            ></polygon>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import ProductListGrid from "./products/ProductListGrid";
// import ProductAttributeFilters from "./products/ProductAttributeFilters";
import AttributeFilter from "@/components/AttributeFilter";
import Breadcrumb from "@/components/Breadcrumb";

export default {
    name: "ProductList",
    components: {
        ProductListGrid,
        // ProductAttributeFilters,
        AttributeFilter,
        Breadcrumb
    },
    data() {
        return {
            sorting_array: [
                { label: "Relevance", value: "" },
                { label: "New", value: "new" },
                { label: "Price, High to Low", value: "price_desc" },
                { label: "Price, Low to High", value: "price_asc" },
                { label: "Name A to Z", value: "name_asc" },
                { label: "Name Z to A", value: "name_desc" }
            ],
            sortBy: null,
            filter: null,
            isBusy: false,
            isbrandShowMore: false,
            iscategoryShowMore: false,
            isgenderAgeShowMore: false,
            iscolorsShowMore: false,
            isattributesShowMore: false,
            issizesShowMore: false,
            ispricesShowMore: false,
            iscolorShadesShowMore: false,
            category_list: [],
            selected_category: "",
            product_list: [],
            brand_list: [],
            gender_age_list: [],
            sleeve_list: [],
            style_category_list: [],
            fabric_list: [],
            color_list: [],
            attribute_list: [],
            productTypeName: "Search",
            productTypePath: "/",
            applied_filters: [],
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                sizeIds: [],
                colorIds: [],
                colorShades: [],
                categoryIds: [],
                priceRanges: [],
                size_groupings: [],
                attribute_options: [],
                searchKeyword: "",
                pms: ""
            },
            listConfigCategory: {
                sortBy: "",
                order: "ASC",
                prod_type_id: this.$route.params.product_type
                    ? this.$route.params.product_type
                    : "all",
                category_id: this.$route.params.category_id
                    ? this.$route.params.category_id
                    : "all"
            },
            category_length: 0,
            pagination_data_length: this.$route.query.page
                ? this.$route.query.page * 18
                : 0,
            currentPage: this.$route.query.page ? this.$route.query.page : 1,
            itemsPerPage: 18,
            prod_type_id: this.$route.params.product_type
                ? this.$route.params.product_type
                : "all",
            category_id: this.$route.params.category_id
                ? this.$route.params.category_id
                : "all",
            refresh_filters_data: true,
            prod_attr_ids: {
                colors_ids: [],
                size_ids: [],
                brands_ids: [],
                size_groupings_ids: [],
                category_ids: [],
                attribute_ids: [],
                attribute_option_ids: []
            },
            prod_attr_values: {
                color_list: [],
                color_shades_list: [],
                gender_age_list: [],
                sizes_list: [],
                brands_list: [],
                category_list: [],
                attributes_list: [],
                price_ranges: [
                    { id: 1, from: 0, to: 9.99 },
                    { id: 2, from: 10, to: 19.99 }
                ]
            },
            original_sizes_list: [],
            breadcrumbs: [],
            price_range: 4.99,
            common_size_groups: [
                {
                    id: "XS-XL",
                    size: "XS-XL",
                    sizes: ["XS", "S", "M", "L", "XL"]
                },
                {
                    id: "7XL-10XL",
                    size: "7XL-10XL",
                    sizes: ["7XL", "8XL", "9XL", "10XL"]
                }
            ],
            shirt_sizes: [
                "XS-XL",
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "XXL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL",
                "7XL",
                "8XL",
                "9XL",
                "10XL",
                "7XL-10XL",
                "11XL",
                "12XL",
                "13XL",
                "14XL",
                "OSFM",
                "YXS",
                "YS",
                "YM",
                "YL",
                "YXL",
                "1T",
                "2T",
                "3T",
                "4T",
                "5T",
                "6T",
                "LT",
                "XLT",
                "2XLT",
                "3XLT",
                "4XLT"
            ],
            filters_count: {},
            query_attributes_loaded: false,
            all_colors_list: [],
            markup_tiers: []
        };
    },
    async beforeMount() {
        await this.getAllMarkupTiers();
    },
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;
        _this.onLoadPage();

        // Second time search click
        this.$root.$on("update-search-data", (data) => {
            this.refresh_filters_data = true;
            this.listConfig.searchKeyword = data.searchKeyword;
            if (this.currentPage == 1) {
                this.getProducts();
            } else {
                this.currentPage = 1;
            }
            this.breadcrumbs = [
                {
                    name:
                        "Search results for: '" +
                        this.listConfig.searchKeyword +
                        "'"
                }
            ];
        });

        this.breadcrumbs = [
            {
                name:
                    "Search results for: '" +
                    this.listConfig.searchKeyword +
                    "'"
            }
        ];
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "printTemplates",
            "embroideryTemplates"
        ]),
        pages() {
            if (this.category_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(
                    Math.ceil(this.category_length / this.itemsPerPage)
                ).keys()
            ].map((e) => e + 1);
        },
        startRange() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endRange() {
            const end = this.currentPage * this.itemsPerPage;
            return end > this.category_length ? this.category_length : end;
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getProducts();
            this.updatePageUrl();
        },
        sortBy(sorting_val) {
            console.log("sorting_val", sorting_val);
            this.listConfig.sorting = sorting_val;
            this.refresh_filters_data = true;
            this.getProducts();
            this.updatePageUrl();
        }
    },
    methods: {
        async onLoadPage() {
            await this.getAllColors();
            this.onloadPrepareQueryFilters();
            if (this.$route.params.product_type == "brand") {
                this.listConfig.category_id = "";
                this.listConfig.prod_type_id = "";
                this.listConfig.brand_id = this.$route.params.category_id;
                this.productTypeName = "Brands";
                this.productTypePath =
                    "/product-list/brand/" + this.$route.params.category_id;
            } else {
                this.productTypeName = "Search";
                this.productTypePath = "/product-list/all/all";
            }

            // First time query string
            this.listConfig.searchKeyword = this.$route.query.q;
            this.getProducts();
        },
        getProducts(pagereset = false) {
            var _this = this;
            _this.isBusy = true;
            new Promise((resolve, reject) => {
                if (pagereset) {
                    _this.currentPage = 1;
                    _this.listConfig.offset = 0;
                }

                let common_size_group_ids = _this.common_size_groups.map(
                    (size_group) => size_group.id
                );
                const params = JSON.parse(JSON.stringify(_this.listConfig));
                params["sizeIds"] = params["sizeIds"].filter(
                    (sizeId) => !common_size_group_ids.includes(sizeId)
                );

                ApiService.post("/get-product-list", params)
                    .then(async ({ data }) => {
                        _this.selected_category = data.categories;
                        _this.category_length = data.products.count;
                        _this.pagination_data_length = data.products.count;
                        _this.product_list = data.products.rows;
                        _this.product_list = data.products.rows.filter(
                            (product) => product.MainNewSubProducts && product.MainNewSubProducts.length > 0
                        );

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.brandIds.length
                        ) {
                            this.prod_attr_ids["brands_ids"] = [];
                        }
                        this.filters_count["brands"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.colorShades.length
                        ) {
                            this.prod_attr_values.color_shades_list = [];
                        }
                        this.filters_count["colorShades"] = {};
                        this.filters_count["colorShadeColors"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.sizeIds.length
                        ) {
                            this.prod_attr_ids["size_ids"] = [];
                        }
                        this.filters_count["sizes"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.size_groupings.length
                        ) {
                            this.prod_attr_ids["size_groupings_ids"] = [];
                        }

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.categoryIds.length
                        ) {
                            this.prod_attr_ids["category_ids"] = [];
                        }
                        this.filters_count["categories"] = {};

                        this.filters_count["priceRanges"] = {};

                        if (
                            !this.query_attributes_loaded ||
                            !this.listConfig.attribute_options.length
                        ) {
                            this.prod_attr_ids["attribute_ids"] = [];
                            this.prod_attr_ids["attribute_option_ids"] = [];
                        }
                        this.filters_count["attributes"] = {};

                        this.product_list.forEach((product) => {
                            product["default_color_id"] = null;
                            let sub_product = (product.MainNewSubProducts || []).find(
                                (sub_product) => sub_product.default_selection
                            );
                            if (sub_product) {
                                product["default_color_id"] =
                                    sub_product.color_id;
                            }

                            let color_ids = product.color_ids
                                ? JSON.parse(product.color_ids)
                                : [];
                            product.colors = (this.all_colors_list || []).filter(
                                (color) => color_ids.includes(color.id)
                            ) || [];

                            _this.getProductAttrIds(product);

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });

                        await _this.getAllFilterValues();
                        _this.isBusy = false;

                        if (!_this.query_attributes_loaded) {
                            _this.onloadPrepareQueryAppliedFacets();
                        }
                        _this.prepareQueryParamsOnRoute();

                        _this.query_attributes_loaded = true;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },
        showMore(attribute) {
            if (typeof attribute == "string") {
                this[attribute] = this[attribute] ? false : true;
                return;
            } else {
                attribute.show_more = attribute.show_more ? false : true;
            }
            this.$forceUpdate();
        },
        CategoryTitle(categories) {
            if (this.$route.name == "search") {
                let searchValue = this.listConfig.searchKeyword
                    ? "Search results for: '" +
                      this.listConfig.searchKeyword +
                      "'"
                    : "Our Best Selling Items";
                return searchValue;
            }
            if (this.$route.params.product_type == "all") {
                let searchValue = this.listConfig.searchKeyword
                    ? 'Search-"' + this.listConfig.searchKeyword + '"'
                    : " ";
                return searchValue;
            }
            if (this.$route.params.product_type == "brand") {
                let brand = this.brand_list.find(
                    (element) => element.id == this.$route.params.category_id
                );
                return brand ? brand.name : "";
            }
            return categories ? categories.title : "";
        },
        CategoryBreadcrumbs(categories) {
            if (this.$route.params.product_type == "all") {
                let searchValue = this.listConfig.searchKeyword
                    ? this.listConfig.searchKeyword
                    : " ";
                return searchValue;
            }
            if (this.$route.params.product_type == "brand") {
                let brand = this.brand_list.find(
                    (element) => element.id == this.$route.params.category_id
                );
                return brand ? brand.name : "";
            }
            return categories ? categories.title : "";
        },
        getAllFilterValues() {
            return new Promise((resolve, reject) => {
                let common_size_group_ids = this.common_size_groups.map(
                    (size_group) => size_group.id
                );
                const params = JSON.parse(JSON.stringify(this.listConfig));
                params["sizeIds"] = params["sizeIds"].filter(
                    (sizeId) => !common_size_group_ids.includes(sizeId)
                );

                let select_additional_filters = {};
                let filter_brand_ids = JSON.parse(
                    localStorage.getItem("filter_brand_ids")
                );
                let filter_category_ids = JSON.parse(
                    localStorage.getItem("filter_category_ids")
                );
                let filter_size_ids = JSON.parse(
                    localStorage.getItem("filter_size_ids")
                );
                let filter_color_ids = JSON.parse(
                    localStorage.getItem("filter_color_ids")
                );
                let filter_price_ranges = JSON.parse(
                    localStorage.getItem("filter_price_ranges")
                );
                let filter_attribute_option_ids = JSON.parse(
                    localStorage.getItem("filter_attribute_option_ids")
                );

                if (filter_brand_ids && params["brandIds"].length) {
                    select_additional_filters["brandIds"] = filter_brand_ids;
                }

                if (filter_category_ids && params["categoryIds"].length) {
                    select_additional_filters["categoryIds"] =
                        filter_category_ids;
                }

                if (filter_size_ids && params["sizeIds"].length) {
                    select_additional_filters["sizeIds"] = filter_size_ids;
                }

                if (filter_color_ids && params["colorIds"].length) {
                    select_additional_filters["colorIds"] = filter_color_ids;
                }

                if (filter_price_ranges && params["priceRanges"].length) {
                    select_additional_filters["priceRanges"] =
                        filter_price_ranges;
                }

                if (
                    filter_attribute_option_ids &&
                    params["attribute_options"].length
                ) {
                    select_additional_filters["attribute_options"] =
                        filter_attribute_option_ids;
                }

                ApiService.post("/get-search-filters", {
                    config: params,
                    select_additional_filters
                })
                    .then(({ data }) => {
                        this.prod_attr_values.color_list = data.colors;
                        this.prod_attr_values.color_list.forEach((color) => {
                            if (color.shades) {
                                let shades = color.shades
                                    ? JSON.parse(color.shades)
                                    : [];
                                shades.forEach((shadeName) => {
                                    const index =
                                        this.prod_attr_values.color_shades_list.findIndex(
                                            (shade) => shade.name == shadeName
                                        );
                                    if (index == -1) {
                                        this.prod_attr_values.color_shades_list.push(
                                            {
                                                id:
                                                    this.prod_attr_values
                                                        .color_shades_list
                                                        .length + 1,
                                                name: shadeName,
                                                products_count: 0,
                                                colors: [color]
                                            }
                                        );
                                    } else {
                                        const color_index =
                                            this.prod_attr_values.color_shades_list[
                                                index
                                            ].colors.findIndex(
                                                (colorObj) =>
                                                    colorObj.id ==
                                                    color.color_id
                                            );
                                        if (color_index == -1) {
                                            this.prod_attr_values.color_shades_list[
                                                index
                                            ].colors.push(color);
                                        }
                                    }
                                });
                            }
                        });

                        if (!params["colorIds"].length) {
                            let all_color_ids = data.colors.map(
                                (color) => color.id
                            );
                            localStorage.setItem(
                                "filter_color_ids",
                                JSON.stringify(all_color_ids)
                            );
                        }

                        this.prod_attr_values.category_list = data.categories;
                        if (!params["categoryIds"].length) {
                            let all_category_ids = data.categories.map(
                                (category) => category.id
                            );
                            localStorage.setItem(
                                "filter_category_ids",
                                JSON.stringify(all_category_ids)
                            );
                        }

                        this.prod_attr_values.brands_list = data.brands;
                        if (!params["brandIds"].length) {
                            let all_brand_ids = data.brands.map(
                                (brand) => brand.id
                            );
                            localStorage.setItem(
                                "filter_brand_ids",
                                JSON.stringify(all_brand_ids)
                            );
                        }

                        this.prod_attr_values.attributes_list = data.attributes;
                        if (!params["attribute_options"].length) {
                            let attribute_option_ids = data.attributes.map(
                                (attribute) => attribute.id
                            );
                            localStorage.setItem(
                                "filter_attribute_option_ids",
                                JSON.stringify(attribute_option_ids)
                            );
                        }

                        this.prod_attr_values.sizes_list = [];
                        let sizes_list = data.sizes;
                        this.original_sizes_list = data.sizes;
                        const sorted_size_names = this.sizesArrangmentSorting(
                            sizes_list.map((size) => size.size)
                        );
                        let sorted_size_objs = [];
                        sorted_size_names.forEach((sorted_size_name) => {
                            sizes_list.forEach((random_size) => {
                                if (random_size.size == sorted_size_name) {
                                    sorted_size_objs.push(random_size);
                                }
                            });
                        });
                        sorted_size_objs.forEach((size) => {
                            const common_size_group =
                                this.common_size_groups.find((size_group) =>
                                    size_group.sizes.includes(size.size)
                                );
                            if (common_size_group) {
                                const index =
                                    this.prod_attr_values.sizes_list.findIndex(
                                        (size) =>
                                            size.id == common_size_group.id
                                    );
                                if (index == -1) {
                                    this.prod_attr_values.sizes_list.push(
                                        common_size_group
                                    );
                                }
                            } else {
                                this.prod_attr_values.sizes_list.push(size);
                            }
                        });
                        if (!params["sizeIds"].length) {
                            let size_ids = data.sizes.map((size) => size.id);
                            localStorage.setItem(
                                "filter_size_ids",
                                JSON.stringify(size_ids)
                            );
                        }

                        this.prod_attr_values.price_ranges = data.price_ranges;
                        if (!params["priceRanges"].length) {
                            localStorage.setItem(
                                "filter_price_ranges",
                                JSON.stringify(data.price_ranges)
                            );
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getColors(colors) {
            this.color_list = [];
            colors.forEach((color) => {
                this.color_list.push({
                    color_name: this.upperCaseFirst(color.name),
                    hash: color.hex,
                    swatches: color.swatches
                });
            });
            this.color_list = this.color_list
                .filter(
                    (item, pos, self) =>
                        self.findIndex((v) => v.hex === item.hex) === pos
                )
                .sort((a, b) => (a.name > b.name ? 1 : -1));
        },
        upperCaseFirst(str) {
            return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
        },
        productImage(images) {
            return images[0]
                ? images[0].image_path
                : "/maincss/images/featured_product_1.png";
        },
        clearFilters(type = "all", id = null) {
            if (type == "all") {
                this.applied_filters.forEach((filter) => {
                    this.listConfig[filter.config_type] = [];
                });
                this.listConfig["colorIds"] = [];
                this.listConfig["pms"] = "";
                this.applied_filters = [];
            } else if (type == "attribute_options") {
                const removableOptionIds = this.applied_filters
                    .filter((filter) => filter.attribute_id == id)
                    .map((filter) => filter.option_id);
                this.listConfig[type] = this.listConfig[type].filter(
                    (filterId) => !removableOptionIds.includes(filterId)
                );
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else if (type == "colorShades") {
                this.listConfig[type] = [];
                this.listConfig["colorIds"] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            } else {
                this.listConfig[type] = [];
                this.applied_filters = this.applied_filters.filter(
                    (filter) => filter.attribute_id != id
                );
            }
            this.refresh_filters_data = type == "all";
            this.getProducts(true);
        },
        removeAppliedFilters(filter) {
            this.applied_filters = this.applied_filters.filter(
                (appliedFilter) =>
                    !(
                        appliedFilter.attribute_id == filter.attribute_id &&
                        filter.option_id == appliedFilter.option_id
                    )
            );
            if (filter.config_type == "priceRanges") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((config) => config.id != filter.option_id);
            } else if (filter.config_type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.id == filter.option_id
                );
                if (common_size_group) {
                    let size_ids = this.original_sizes_list
                        .filter((size) =>
                            common_size_group.sizes.includes(size.size)
                        )
                        .map((size) => size.id);
                    this.listConfig[filter.config_type] = this.listConfig[
                        filter.config_type
                    ].filter((sizeId) => !size_ids.includes(sizeId));
                }
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            } else if (filter.config_type == "colorShades") {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
                let shade = this.prod_attr_values.color_shades_list.find(
                    (shade) => shade.name == filter.option_id
                );
                let unchecked_shade_colors = shade.colors.map(
                    (color) => color.id
                );
                this.listConfig["colorIds"] = this.listConfig[
                    "colorIds"
                ].filter(
                    (colorId) =>
                        !unchecked_shade_colors.includes(parseInt(colorId))
                );
            } else if (filter.config_type == "pms") {
                this.listConfig[filter.config_type] = "";
            } else {
                this.listConfig[filter.config_type] = this.listConfig[
                    filter.config_type
                ].filter((configId) => configId != filter.option_id);
            }
            this.refresh_filters_data = false;
            this.getProducts(true);
        },
        filterProducts(event, value, type, attributeId, option_label) {
            if (type == "priceRanges") {
                if (event.target.checked == true) {
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value.id,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label: `$${value.from} - $${value.to}`
                    });
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option.id != value.id
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value.id == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "sizeIds") {
                const common_size_group = this.common_size_groups.find(
                    (size_group) => size_group.size == value
                );
                // console.log(common_size_group)
                if (event.target.checked == true) {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] =
                            this.listConfig[type].concat(size_ids);
                    }
                    this.listConfig[type].push(value);
                    this.applied_filters.push({
                        option_id: value,
                        config_type: type,
                        attribute_id: attributeId,
                        option_label
                    });
                } else {
                    if (common_size_group) {
                        let size_ids = this.original_sizes_list
                            .filter((size) =>
                                common_size_group.sizes.includes(size.size)
                            )
                            .map((size) => size.id);
                        this.listConfig[type] = this.listConfig[type].filter(
                            (sizeId) => !size_ids.includes(sizeId)
                        );
                    }
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            } else if (type == "pms") {
                let filter_index = this.applied_filters.findIndex(
                    (filter) => filter.config_type == "pms"
                );
                if (event.target.checked == true) {
                    if ((!value || !value.trim()) && filter_index >= 0) {
                        this.removeAppliedFilters(
                            this.applied_filters[filter_index]
                        );
                        return;
                    } else if (
                        (!value || !value.trim()) &&
                        filter_index == -1
                    ) {
                        return;
                    }

                    if (filter_index >= 0) {
                        this.applied_filters[filter_index]["option_label"] =
                            value.trim();
                    } else {
                        this.applied_filters.push({
                            option_id: "pms",
                            config_type: "pms",
                            attribute_id: "pms",
                            option_label: value.trim()
                        });
                    }
                    this.listConfig[type] = value.trim();
                } else {
                    this.removeAppliedFilters(
                        this.applied_filters[filter_index]
                    );
                }
            } else {
                if (event.target.checked == true) {
                    if (!this.listConfig[type].includes(value)) {
                        this.listConfig[type].push(value);
                    }
                    if (
                        !this.applied_filters.find(
                            (filter) => filter.option_id == value
                        )
                    ) {
                        this.applied_filters.push({
                            option_id: value,
                            config_type: type,
                            attribute_id: attributeId,
                            option_label
                        });
                    }
                    if (type == "colorShades") {
                        if (this.listConfig["colorIds"].length == 0) {
                            let shade =
                                this.prod_attr_values.color_shades_list.find(
                                    (shade) => shade.name == value
                                );
                            let shade_color_ids = shade.colors.map(
                                (color) => color.id
                            );
                            this.listConfig["colorIds"] = [
                                ...new Set(
                                    this.listConfig["colorIds"].concat(
                                        shade_color_ids
                                    )
                                )
                            ];
                        }
                    }
                } else {
                    this.listConfig[type] = this.listConfig[type].filter(
                        (option) => option != value
                    );
                    this.applied_filters = this.applied_filters.filter(
                        (filter) =>
                            !(
                                filter.attribute_id == attributeId &&
                                value == filter.option_id
                            )
                    );
                    if (type == "colorShades") {
                        let shade =
                            this.prod_attr_values.color_shades_list.find(
                                (shade) => shade.name == value
                            );
                        let unchecked_shade_colors = shade.colors.map(
                            (color) => color.id
                        );
                        this.listConfig["colorIds"] = this.listConfig[
                            "colorIds"
                        ].filter(
                            (colorId) =>
                                !unchecked_shade_colors.includes(
                                    parseInt(colorId)
                                )
                        );
                    }
                }
                this.listConfig[type] = [...new Set(this.listConfig[type])];
            }
            this.refresh_filters_data = false;
            this.getProducts(true);
        },
        preparePriceRanges() {
            let highestPrice = 0;
            this.product_list.forEach((product) => {
                if (
                    parseFloat(highestPrice) <
                    parseFloat(product.lowest_base_price)
                ) {
                    highestPrice = parseFloat(product.lowest_base_price) + 1;
                }
            });
            if (!this.listConfig.priceRanges.length) {
                let priceRanges = [];
                let currentRange = 0;
                const rangeSize = this.price_range;

                let i = 0;
                while (currentRange < highestPrice) {
                    const rangeStart = currentRange;
                    const rangeEnd = Math.min(
                        currentRange + rangeSize,
                        highestPrice
                    );
                    priceRanges.push({
                        id: i + 1,
                        from: parseFloat(rangeStart).toFixed(2),
                        to: parseFloat(rangeEnd).toFixed(2)
                    });
                    currentRange += rangeSize + 0.01;
                    i++;
                }
                this.prod_attr_values.price_ranges = priceRanges;
            }
        },
        prepareFiltersCount() {
            this.product_list.forEach((product) => {
                // BRAND COUNT
                // if (!this.listConfig.brandIds.length) {

                if (!this.filters_count["brands"]) {
                    this.filters_count["brands"] = { [product.brand_id]: 1 };
                } else if (!this.filters_count["brands"][product.brand_id]) {
                    this.filters_count["brands"][product.brand_id] = 1;
                } else {
                    this.filters_count["brands"][product.brand_id]++;
                }
                // }

                // COLOR SHADES COUNT
                // if (!this.listConfig.colorShades.length) {
                // let color_shades = product.MainNewSubProducts.map(subProduct =>subProduct.Color.shades).filter(n =>n);
                let color_shades = [];
                (product.MainNewSubProducts || []).forEach((subProduct) => {
                    if (subProduct.Color && subProduct.Color.shades) {
                        let shades = subProduct.Color.shades
                            ? JSON.parse(subProduct.Color.shades)
                            : [];
                        color_shades = color_shades.concat(shades);
                    }
                });
                color_shades = [...new Set(color_shades)];
                color_shades.forEach((shade) => {
                    if (!this.filters_count["colorShades"]) {
                        this.filters_count["colorShades"] = { [shade]: 1 };
                    } else if (!this.filters_count["colorShades"][shade]) {
                        this.filters_count["colorShades"][shade] = 1;
                    } else {
                        this.filters_count["colorShades"][shade]++;
                    }

                    let color_ids = (product.MainNewSubProducts || []).filter(
                        (subProduct) =>
                            subProduct.Color && subProduct.Color.shades == shade
                    ).map((subProduct) => subProduct.color_id);
                    color_ids = [...new Set(color_ids)];

                    color_ids.forEach((colorId) => {
                        if (!this.filters_count["colorShadeColors"]) {
                            this.filters_count["colorShadeColors"] = {
                                [shade]: { [colorId]: 1 }
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade]
                        ) {
                            this.filters_count["colorShadeColors"][shade] = {
                                [colorId]: 1
                            };
                        } else if (
                            !this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]
                        ) {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ] = 1;
                        } else {
                            this.filters_count["colorShadeColors"][shade][
                                colorId
                            ]++;
                        }
                    });
                });
                // }

                // SIZES COUNT
                // if (!this.listConfig.sizeIds.length) {
                let sizes = (product.MainNewSubProducts || []).map(
                    (subProduct) => subProduct.size_id
                );
                sizes = [...new Set(sizes)];
                sizes.forEach((size) => {
                    if (!this.filters_count["sizes"]) {
                        this.filters_count["sizes"] = { [size]: [product.id] };
                    } else if (!this.filters_count["sizes"][size]) {
                        this.filters_count["sizes"][size] = [product.id];
                    } else {
                        this.filters_count["sizes"][size].push(product.id);
                    }
                });
                // }

                // PRICE RANGES COUNT
                // if (!this.listConfig.priceRanges.length) {
                this.prod_attr_values.price_ranges.forEach((priceRange) => {
                    if (
                        parseFloat(product.lowest_base_price) >=
                            parseFloat(priceRange.from) &&
                        parseFloat(product.lowest_base_price) <=
                            parseFloat(priceRange.to)
                    ) {
                        if (!this.filters_count["priceRanges"]) {
                            this.filters_count["priceRanges"] = {
                                [priceRange.id]: 1
                            };
                        } else if (
                            !this.filters_count["priceRanges"][priceRange.id]
                        ) {
                            this.filters_count["priceRanges"][
                                priceRange.id
                            ] = 1;
                        } else {
                            this.filters_count["priceRanges"][priceRange.id]++;
                        }
                    }
                });
                // }

                // ATTRIBUTES COUNT
                // if (!this.listConfig.attribute_options.length) {
                if (product.ProductAttribute) {
                    const attributeOptions = JSON.parse(
                        product.ProductAttribute.attribute_options
                    );
                    attributeOptions.forEach((optionId) => {
                        if (!this.filters_count["attributes"]) {
                            this.filters_count["attributes"] = {
                                [optionId]: 1
                            };
                        } else if (
                            !this.filters_count["attributes"][optionId]
                        ) {
                            this.filters_count["attributes"][optionId] = 1;
                        } else {
                            this.filters_count["attributes"][optionId]++;
                        }
                    });
                }
                // }

                // CATEGORIES COUNT
                // if (!this.listConfig.categoryIds.length) {
                let category_ids = product.category_ids
                    ? JSON.parse(product.category_ids)
                    : [];
                category_ids.forEach((categoryId) => {
                    if (!this.filters_count["categories"]) {
                        this.filters_count["categories"] = { [categoryId]: 1 };
                    } else if (!this.filters_count["categories"][categoryId]) {
                        this.filters_count["categories"][categoryId] = 1;
                    } else {
                        this.filters_count["categories"][categoryId]++;
                    }
                });
                // }
            });
        },
        queryParams(config) {
            let colorShades = config.colorShades
                ? config.colorShades.map((shade) => this.toSnakeCase(shade))
                : [];
            let priceRanges = config.priceRanges
                ? config.priceRanges.map((range) => `${range.from}_${range.to}`)
                : [];
            let updatedParams = {
                attributes: config.attribute_options.join(",") || undefined,
                brands: config.brandIds.join(",") || undefined,
                sizes: config.sizeIds.join(",") || undefined,
                colorShades: colorShades.join(",") || undefined,
                colors: config.colorIds.join(",") || undefined,
                categories: config.categoryIds.join(",") || undefined,
                prices: priceRanges.join(",") || undefined,
                q: this.$router.currentRoute.query.q || undefined,
                pms: config.pms || undefined,
                page: this.currentPage || undefined
            };

            updatedParams = this.removeEmptyKeys(updatedParams);

            return updatedParams;
        },
        prepareQueryParamsOnRoute() {
            const currentRoute = { ...this.$router.currentRoute }; // Copy the current route object
            currentRoute.query = { ...currentRoute.query };
            let updatedParams = this.queryParams(this.listConfig);

            const hasDifferentQueryParams =
                JSON.stringify(currentRoute.query) !==
                JSON.stringify(updatedParams);
            if (hasDifferentQueryParams) {
                currentRoute.query = updatedParams;
                this.$router.replace(currentRoute);
            }
        },
        onloadPrepareQueryFilters() {
            let queryParams = this.$route.query;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));

            let routeCategories = queryParams.categories
                ? queryParams.categories.split(",")
                : [];
            routeCategories = routeCategories.map((attrOption) =>
                parseInt(attrOption)
            );

            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );

            let routeColors = queryParams.colors
                ? queryParams.colors.split(",")
                : [];
            routeColors = routeColors.map((attrOption) => parseInt(attrOption));

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );

            let routePMS = queryParams.pms || "";

            this.listConfig = {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: routeBrands,
                size_groupings: [],
                colorNames: [],
                sizeIds: routeSizes,
                colorIds: routeColors,
                colorShades: routeColorShades,
                pms: routePMS,
                prod_type_id: this.$route.params.product_type,
                category_id: null,
                categoryIds: routeCategories,
                priceRanges: routePrices,
                sorting: "",
                attribute_options: routeAttributeOptions
            };
        },
        onloadPrepareQueryAppliedFacets() {
            this.applied_filters = [];

            let queryParams = this.$route.query;

            let routeBrands = queryParams.brands
                ? queryParams.brands.split(",")
                : [];
            routeBrands = routeBrands.map((attrOption) => parseInt(attrOption));
            routeBrands.forEach((brandId) => {
                let brand = this.prod_attr_values.brands_list.find(
                    (brand) => brand.id == parseInt(brandId)
                );
                if (brand) {
                    this.applied_filters.push({
                        attribute_id: "Brands",
                        config_type: "brandIds",
                        option_id: brandId,
                        option_label: brand.name
                    });
                }
            });

            let routeCategories = queryParams.categories
                ? queryParams.categories.split(",")
                : [];
            routeCategories = routeCategories.map((attrOption) =>
                parseInt(attrOption)
            );
            routeCategories.forEach((categoryId) => {
                let category = this.prod_attr_values.category_list.find(
                    (category) => category.id == parseInt(categoryId)
                );
                if (category) {
                    this.applied_filters.push({
                        attribute_id: "Categories",
                        config_type: "categoryIds",
                        option_id: categoryId,
                        option_label: category.title
                    });
                }
            });

            let routeColorShades = queryParams.colorShades
                ? queryParams.colorShades.split(",")
                : [];
            routeColorShades = routeColorShades.map((attrOption) =>
                this.toTitleCase(attrOption)
            );
            routeColorShades.forEach((colorShade) => {
                let shade = this.prod_attr_values.color_shades_list.find(
                    (shade) => shade.name == colorShade
                );
                if (shade) {
                    this.applied_filters.push({
                        attribute_id: "ColorShades",
                        config_type: "colorShades",
                        option_id: colorShade,
                        option_label: shade.name
                    });
                }
            });

            let routeSizes = queryParams.sizes
                ? queryParams.sizes.split(",")
                : [];
            routeSizes = routeSizes.map((attrOption) =>
                !parseInt(attrOption) ? attrOption : parseInt(attrOption)
            );
            routeSizes.forEach((sizeId) => {
                let size = this.prod_attr_values.sizes_list.find(
                    (size) => size.id == sizeId
                );
                if (size) {
                    this.applied_filters.push({
                        attribute_id: "Sizes",
                        config_type: "sizeIds",
                        option_id: sizeId,
                        option_label: size.size
                    });
                }
            });

            let routePrices = queryParams.prices
                ? queryParams.prices.split(",")
                : [];
            routePrices = routePrices.map((price) => ({
                from: parseFloat(price.split("_")[0]),
                to: parseFloat(price.split("_")[1])
            }));
            routePrices.forEach((price) => {
                let priceRange = this.prod_attr_values.price_ranges.findIndex(
                    (currentprice) => currentprice.to == price.to
                );
                if (priceRange >= 0) {
                    this.applied_filters.push({
                        attribute_id: "Prices",
                        config_type: "priceRanges",
                        option_id: priceRange,
                        option_label: `$${price.from} - $${price.to}`
                    });
                }
            });

            let routeAttributeOptions = queryParams.attributes
                ? queryParams.attributes.split(",")
                : [];
            routeAttributeOptions = routeAttributeOptions.map((attrOption) =>
                parseInt(attrOption)
            );
            this.prod_attr_values.attributes_list.forEach((attr) => {
                attr.AttributeOptions.forEach((option) => {
                    if (routeAttributeOptions.includes(option.id)) {
                        this.applied_filters.push({
                            attribute_id: `Attribute-${attr.id}`,
                            config_type: "attribute_options",
                            option_id: option.id,
                            option_label: option.category
                        });
                    }
                });
            });

            let routePMS = queryParams.pms || null;
            if (routePMS) {
                this.applied_filters.push({
                    attribute_id: "pms",
                    config_type: "pms",
                    option_id: "pms",
                    option_label: routePMS
                });
            }
        },
        getCategories() {
            var _this = this;
            new Promise((resolve, reject) => {
                ApiService.post(
                    "/home-new-product-type-categories",
                    _this.listConfigCategory
                )
                    .then(({ data }) => {
                        _this.category_list = data.categories.rows;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllFavoriteProducts(productIds) {
            ApiService.post("/get-favorite-by-product-ids", { ids: productIds })
                .then(({ data }) => {
                    let favourite_product_ids = data.favorite.map(
                        (product) => product.product_id
                    );
                    this.product_list.forEach((product) => {
                        if (this.$refs[`bottom-links-${product.id}`]) {
                            let bottom_element =
                                this.$refs[`bottom-links-${product.id}`][0];
                            if (bottom_element) {
                                if (bottom_element.is_favorite_product) {
                                    bottom_element.is_favorite_product =
                                        favourite_product_ids.includes(
                                            product.id
                                        );
                                }
                                if (bottom_element.favorite_product) {
                                    bottom_element.favorite_product =
                                        data.favorite.find(
                                            (fav) =>
                                                fav.product_id == product.id
                                        );
                                }
                            }
                        }
                    });
                })
                .catch((response) => {
                    console.log(response);
                });
        },
        getProductAttrIds(productObj) {
            if (
                !this.query_attributes_loaded ||
                !this.listConfig.sizeIds.length
            ) {
                let size_ids = (productObj.MainNewSubProducts || []).map(
                    (subProduct) => subProduct.size_id
                );
                this.prod_attr_ids.size_ids = [
                    ...new Set(this.prod_attr_ids.size_ids.concat(size_ids))
                ];
            }

            if (
                !this.query_attributes_loaded ||
                (!this.listConfig.brandIds.length &&
                    !this.prod_attr_ids["brands_ids"].includes(
                        productObj.brand_id
                    ))
            ) {
                if (
                    !this.prod_attr_ids.brands_ids.includes(productObj.brand_id)
                ) {
                    this.prod_attr_ids.brands_ids.push(productObj.brand_id);
                }
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.categoryIds.length
            ) {
                let category_ids = productObj.category_ids
                    ? JSON.parse(productObj.category_ids)
                    : [];
                this.prod_attr_ids.category_ids = [
                    ...new Set(
                        this.prod_attr_ids.category_ids.concat(category_ids)
                    )
                ];
            }

            if (
                !this.query_attributes_loaded ||
                !this.listConfig.size_groupings.length
            ) {
                let size_groupings_ids = productObj.size_groupings
                    ? JSON.parse(productObj.size_groupings)
                    : [];
                this.prod_attr_ids.size_groupings_ids = [
                    ...new Set(
                        this.prod_attr_ids.size_groupings_ids.concat(
                            size_groupings_ids
                        )
                    )
                ];
            }

            if (productObj.ProductAttribute) {
                if (productObj.ProductAttribute.attribute_ids) {
                    let attribute_ids = JSON.parse(
                        productObj.ProductAttribute.attribute_ids
                    );
                    this.prod_attr_ids.attribute_ids = [
                        ...new Set(
                            this.prod_attr_ids.attribute_ids.concat(
                                attribute_ids
                            )
                        )
                    ];
                }
                if (productObj.ProductAttribute.attribute_options) {
                    let attribute_options = JSON.parse(
                        productObj.ProductAttribute.attribute_options
                    );
                    this.prod_attr_ids.attribute_option_ids = [
                        ...new Set(
                            this.prod_attr_ids.attribute_option_ids.concat(
                                attribute_options
                            )
                        )
                    ];
                }
            }
        },
        insertUniqueValueToArr(array_data, newValue) {
            if (newValue && !array_data.includes(newValue)) {
                array_data.push(newValue);
            }
        },

        updatePageUrl() {
            // Write some code
        },
        resetPaginationAndRefreshData() {
            let _this = this;
            _this.currentPage = 1;
            _this.listConfig.offset = 0;
        },
        sizesArrangmentSorting(all_sizes) {
            var all_product_sizes = JSON.parse(
                JSON.stringify(this.shirt_sizes)
            );
            all_sizes.forEach((size) => {
                if (!all_product_sizes.includes(size)) {
                    all_product_sizes.push(size);
                }
            });

            var ar1 = all_product_sizes;
            var ar2 = all_sizes;

            var tmpar = [];
            for (var i = 0; i < ar1.length; i++) {
                if (ar2.indexOf(ar1[i]) !== -1) {
                    tmpar.push(ar1[i]);
                }
            }
            ar1 = tmpar;
            return ar1;
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>
